import { OrderedMap } from 'immutable';
import Note from '@repo/utils/models/Note';
import Contact from '@repo/utils/models/Contact';
import type { ID, ReduxAction } from '@repo/utils/types';
import AppState from '../app-state';

export type SharedNotesState = OrderedMap<ID, Note>;
const initialSharedNotesState = OrderedMap<ID, Note>();

export const selectSharedContactNotes = (contactUUID: ID) => (state: AppState) =>
  state.sharedData.notes
    .filter((note: Note | undefined) => note?.contact.id == contactUUID)
    .valueSeq()
    .toArray();

export function sharedNotesReducer(
  state: SharedNotesState = initialSharedNotesState,
  { type, payload }: ReduxAction,
): SharedNotesState {
  switch (type) {
    case 'FETCH_ALL_SHARED_CONTACT_NOTES_SUCCEEDED':
      if (!payload?.results?.length) {
        return state;
      }

      return state.merge(
        (payload.results || []).map((note: any) => [
          note.id.toString(),
          new Note({
            ...note,
            contact: new Contact({ id: payload.contactUUID }),
          }),
        ]),
      );

    default:
      return state;
  }
}
